import { Tooltip } from "antd";
import "./index.css";

export const IndividualInclusionMemberToolTip = ({ title, isExcluded = false }) => {
  return (
    <Tooltip
      placement="top"
      title={title}
    >
      <span className="individual-inclusion-member-text">{isExcluded? "*" : "**"}</span>
    </Tooltip>
  );
};
